<template>
  <div class="driversLicenseInfo">
    <QS-h4-title title="驾驶证" />
    <QS-column-box
      :source="source"
      :list="list"
      :column="3"
      labelWidth="200"
      separator=":"
    >
      <template slot="driverLicenceUrl">
        <EnlargeImg :imgSrc="source.driverLicenceUrl||''" class="avatar" />
      </template>
      <template slot="driverLicenceBackUrl">
        <EnlargeImg :imgSrc="source.driverLicenceBackUrl||''" class="avatar" />
      </template>
      <template slot="driverLicenceValidDate">
        {{ longDate }}
      </template>
    </QS-column-box>
  </div>
</template>
<script>
import { longDateFormat } from '@/utils'

export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    longDate() {
      return longDateFormat('driverLicenceValidDate', this.source)
    },
  },
}
</script>

<style lang="scss" scoped>
.driversLicenseInfo{
  .positive{
    display: flex;
    width: 50%;
  }

  .reverse{
    display: flex;
    width: 50%;
  }

  span{
    text-align: right;
    padding-right: 10px;
    color: #333333;
    width: 150px;
  }

  img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
